import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './en';
import zh from './zh';
import ru from './ru';
import fr from './fr';
import es from './es';
import pt from './pt';
import de from './de';
import ar from './ar';
import ja from './ja';
import ko from './ko';
import id from './id';

Vue.use(VueI18n);

const messages = { en, zh, ru, fr, es, pt, de, ar, ja, ko, id };

// Detect browser language with fallback
const locale = navigator.language.split('-')[0] || 'en';

const i18n = new VueI18n({
  locale: [
    'en',
    'zh',
    'ru',
    'fr',
    'es',
    'pt',
    'de',
    'ar',
    'ja',
    'ko',
    'id',
  ].includes(locale)
    ? locale
    : 'en',
  fallbackLocale: 'en',
  messages,
});

export default i18n;
